import './App.css';
import './components/keyframes/primary/slide_kfr.css'
import './components/keyframes/primary/zout_kfr.css'
import './components/keyframes/primary/zin_kfr.css'
import './components/keyframes/primary/rotate_kfr.css'
import './components/keyframes/primary/flip_kfr.css'
import './components/keyframes/primary/shade_kfr.css'

import './components/keyframes/entrances/swirlIn_kfr.css'
import './components/keyframes/entrances/fadeIn_kfr.css'
import './components/keyframes/entrances/tilt_kfr.css'
import './components/keyframes/entrances/bounceRollIn_kfr.css'
import './components/keyframes/entrances/flipSlitIn_kfr.css'
import './components/keyframes/entrances/bounceRollIn_kfr.css'
import './components/keyframes/entrances/rotateIn_kfr.css'
import './components/keyframes/entrances/slideIn_kfr.css'

import './components/keyframes/exit/swirlOut_kfr.css'
import './components/keyframes/exit/fadeOut_kfr.css'
import './components/keyframes/exit/bounceRollOut_kfr.css'
import './components/keyframes/exit/flipSlitOut_kfr.css'
import './components/keyframes/exit/bounceRollOut_kfr.css'
import './components/keyframes/exit/rotateOut_kfr.css'
import './components/keyframes/exit/slideOut_kfr.css'

import './components/keyframes/text/trackin_kfr.css'
import './components/keyframes/text/trackout_kfr.css'
import './components/keyframes/text/focus_kfr.css'
import './components/keyframes/text/shadow_kfr.css'
import './components/keyframes/attnBkg/attention_kfr.css'
import './components/shapes.css';
import Lmenu1 from './components/Lmenu1';
import Navbar_left from './components/Navbar_left';
import React,{useState,useEffect} from 'react';
import Shapenav from './components/Shapenav';
import Navbar_top from './components/Navbar_top';
import Entity from './components/Entity';
import Table from './components/Table';
import Cubicbz from './components/Cubicbz';
import Rightnav from './components/Rightnav';
import Code from './components/Code';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import Hamburg from './components/Hamburg';
import About from './components/About';
import FAQ from './components/FAQ';
import Howto from './components/Howto';
import Contact from './components/Contact';

import Respbn from './components/Respbn';
import Timeinfo from './components/Timeinfo';
import Download from './components/Download';
import HOC from './components/HOC';
import Signup from './components/auth/Signup';
import Signin from './components/auth/Signin';
import axios from 'axios';
import Landing from './components/Landing';
import Page404 from './components/Page404';
import Grid from './components/Grid';


function App() {


  const [Tdata,setTdata]=useState([0.5,0,1,'normal','both']);
  const [flg,setflg]=useState(true);
  const [lmit,updlmit]=useState(['sl-left','sl-right','sl-top','sl-bottom','sl-top-right','sl-top-left','sl-bottom-right','sl-bottom-left','sl-bk-center','sl-bk-top','sl-bk-tr','sl-bk-right','sl-bk-br','sl-bk-bottom','sl-bk-bl','sl-bk-left','sl-bk-tl','sl-fwd-center','sl-fwd-top','sl-fwd-tr','sl-fwd-right','sl-fwd-br','sl-fwd-bottom','sl-fwd-bl','sl-fwd-left','sl-fwd-tl','sl-rot-hor-top','sl-rot-hor-t-bk','sl-rot-hor-t-fwd','sl-rot-ver-right','sl-rot-ver-r-bck','sl-rot-ver-r-fwd','sl-rot-hor-btm','sl-rot-hor-b-bk','sl-rot-hor-b-fwd','sl-rot-ver-left','sl-rot-ver-t-bck','sl-rot-ver-t-fwd']);
  const [toproute,settoproute]=useState("Primary");
  const [leftroute,setleftroute]=useState("Slide")
  const [apidata,setapidata]=useState({data:{0:{['']:"please select"}}})
  const [Nlkey,setNlkey]=useState('')
  const [send2code,setsend2code]=useState('')
  const [txorder,settxorder]=useState(true)
  const [bzval,setbzval]=useState("cubic-bezier(0.455, 0.030, 0.515, 0.955)")
  const [shpval,setshpval]=useState({data:{0:{['']:"please select"}}})
  const [shpkey,setshpkey]=useState("square")
  const [Repval,setRepval]=useState()
  const [entgl,setEntgl]=useState()
  const [stat,setStat]=useState("static")
  const [dwTgl,setDwTgl]=useState()
  
  


    
  
  const updt=(lst)=>{
    updlmit(lst);
  }
  const [msg,updmsg]=useState('')
  const fech=(str)=>{
    updmsg(str);
  }
  const tableData=(ls)=>{
    setTdata(ls);
  }
  const rte=(str)=>{
    settoproute(str)
  }
  const leftrte=(str)=>{
    setleftroute(str)
  }
  const apiresp=(obj)=>{
    setapidata(obj)
  }
  const Nlkeyget=(str)=>{
    setNlkey(str)
  }
  const data2code=(str)=>{
    setsend2code(str)
  }
  const order=(flg)=>{
    settxorder(flg)
  }
  const beizr=(bzvl)=>{
    setbzval(bzvl)
  }
  const shp2code=(shp)=>{
    setshpval(shp)
  }
  const shapekey=(key)=>{
    setshpkey(key)
  }
  const rep=(boolval)=>{
    setRepval(boolval)
  }
  const entoogle=(boolval)=>{
    setEntgl(boolval)
  }
  const stats=(str)=>{
    setStat(str)
  }
  const dwglu=(bol)=>{
    setDwTgl(bol)
  }
  return (
    <BrowserRouter>
     {
      navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i)?<div className=' notu' style={{color:'red'}}>
        <h2>**Important Update: Mobile Accessibility Coming Soon!**</h2>
        <h4>We're sorry for any inconvenience, but our website is currently unavailable on Android and mobile devices due to technical issues. Rest assured, we're working hard to bring you a mobile-friendly experience in the near future. In the meantime, enjoy our content on your PC. Stay tuned for updates, and thank you for your patience!</h4>
      </div>:
    
    <HOC >
      <Routes>

        <Route path='/' element={<Landing/>}></Route>
        <Route path='/playground' element={
        <div className='mainBody'>
          
          <Hamburg/>
      <Navbar_left updt={updt} leftrte={leftrte} toproute={toproute} apiresp={apiresp} Nlkeyget={Nlkeyget} />
      <Lmenu1 disp={lmit} fech={fech} toproute={toproute} leftroute={leftroute} Nlkey={Nlkey} data2code={data2code} msg={msg}/> 
      <div className='Lmenu2 flex' id='Lmenu2id'>
      <div className='ap flex' style={{justifyContent:"center",flexDirection:"row",flexWrap:"wrap"}}>
        <Shapenav shp2code={shp2code} shapekey={shapekey}/>
        <Table tableData={tableData}/>
      </div>
        <Cubicbz beizr={beizr}/>
      </div>
      <Navbar_top flg={flg} setflg={setflg} rte={rte} order={order}/>
      <div className='elbox flex'>
         <Entity MSG={msg} Tdata={Tdata} txorder={txorder} bzval={bzval} Repval={Repval} entoogle={entoogle} stats={stats}/>
         <Timeinfo Tdata={Tdata} MSG={msg} entgl={entgl} stat={stat}/>
      </div>
      <Rightnav rep={rep} msg={msg} dwglu={dwglu}/>
      <Code apidata={apidata} send2code={send2code} shpval={shpval} shpkey={shpkey} msg={msg} Tdata={Tdata} bzval={bzval} />
      <Download dwTgl={dwTgl} msg={msg}/>
      <Respbn/>
      <Grid/>
        </div>}>
        </Route>
        <Route path='/about' element={<About/>}></Route>
        <Route path='/faq' element={<FAQ/>}></Route>
        <Route path='/howto' element={<Howto/>}></Route>
        <Route path='/contact' element={<Contact/>}></Route>
        <Route path='/signup' element={<Signup/>}></Route>
        <Route path='/signin' element={<Signin/>}></Route>
        <Route path='*' element={<Page404/>}></Route>
      </Routes>
      </HOC>
    }
    </BrowserRouter>
   
  );
}

export default App;

